import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import MUIDialog from '@mui/material/Dialog';
import useTranslation from 'next-translate/useTranslation';

import { DialogProps } from './props';

export const Dialog: React.FC<DialogProps> = (props) => {
  const {
    title,
    children,
    dialogContentProps,
    dialogTitleProps,
    disableButton = false,
    MainActionButtonProps,
    onClose,
    contentAlignment = 'left',
    open = false,
    maxWidth = 'sm',
    cancelLabel,
    cancelButtonProps,
    closeButtonTop = false,
    ...rest
  } = props;

  // ======================= HOOKS
  const { t } = useTranslation('common');

  // ======================= VIEWS
  return (
    <MUIDialog
      {...rest}
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '10px',
          display: 'flex',
          minWidth: { md: 600 },
        },
      }}
    >
      <DialogTitle
        {...dialogTitleProps}
        sx={{
          fontSize: 20,
          fontWeight: 500,
          ...dialogTitleProps?.sx,
        }}
      >
        {title}
        {closeButtonTop && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 12,
              top: 16,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent
        {...dialogContentProps}
        sx={{
          textAlign: contentAlignment === 'center' ? 'center' : 'left',
          ...dialogContentProps?.sx,
        }}
      >
        {children}
      </DialogContent>
      {!disableButton && (
        <DialogActions>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              px: 6,
            }}
            {...cancelButtonProps}
          >
            {cancelLabel || t('cancel')}
          </Button>
          <Button
            variant="contained"
            onClick={MainActionButtonProps?.onClick}
            autoFocus
            color={MainActionButtonProps?.color || 'primary'}
            sx={{
              px: 6,
            }}
            {...MainActionButtonProps}
          >
            {MainActionButtonProps?.label}
          </Button>
        </DialogActions>
      )}
    </MUIDialog>
  );
};

// ======================= EXPORT
export default Dialog;
